import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import PrivateRoutes from './PrivateRoutes'
// import {ErrorsPage} from '../modules/errors/ErrorsPage'
import PublicRoutes from './PublicRoutes'
import App from '../containers/app'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { RootState } from '../redux/store'
import { getCurrentUser } from '../redux/actions/Auth'
import Loader from '../components/loader'
import 'react-toastify/dist/ReactToastify.css'
import Dialogs from '../components/dialogs'

const AppRoutes: FC = () => {
    const dispatch = useAppDispatch()
    const { apiToken, currentUser } = useAppSelector((state: RootState) => state.AuthReducer)
    if (apiToken && !currentUser) {
        dispatch(getCurrentUser())
    }
    return (
        <>
            <BrowserRouter>
                <Loader />
                <Routes>
                    <Route element={<App />}>
                        {currentUser ? (
                            <>
                                <Route path='/*' element={<PrivateRoutes />} />
                                <Route index element={<Navigate to='/dashboard' />} />
                            </>
                        ) : (
                            <>
                                <Route path='auth/*' element={<PublicRoutes />} />
                                <Route path='*' element={<Navigate to='/auth' />} />
                            </>
                        )}
                    </Route>
                </Routes>
                <Dialogs />
            </BrowserRouter>
            <ToastContainer autoClose={3000} theme='colored' />
        </>
    )
}

export default AppRoutes
